import { i18n } from '@lingui/core';
import { getLocales } from 'expo-localization';

import { getLang, locales } from '../../../locales';

const lang = getLocales()[0].languageTag;
const langKey = getLang(lang);

// 初始化 i18n
i18n.load(locales);
i18n.activate(langKey);

export { i18n };
